import { render, staticRenderFns } from "./OOSPopUp.vue?vue&type=template&id=2729095d&scoped=true&"
import script from "./OOSPopUp.vue?vue&type=script&lang=js&"
export * from "./OOSPopUp.vue?vue&type=script&lang=js&"
import style0 from "./OOSPopUp.vue?vue&type=style&index=0&id=2729095d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2729095d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\src\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2729095d')) {
      api.createRecord('2729095d', component.options)
    } else {
      api.reload('2729095d', component.options)
    }
    module.hot.accept("./OOSPopUp.vue?vue&type=template&id=2729095d&scoped=true&", function () {
      api.rerender('2729095d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "BuildABox/components/OOSPopUp.vue"
export default component.exports